import React from 'react';

export const RecipeContext = React.createContext({});
export const RecipeContextProvider = RecipeContext.Provider;
export const RecipeContextConsumer = RecipeContext.Consumer;
